import { useTheme } from '@emotion/react';
import { Tab, Tabs } from '@mui/material';
import { getServiceName } from '@repo/utils';

import { useTabListContext } from './TabListContext';

function TabList() {
  const { tabList, activateTabItem, onTabClick } = useTabListContext();
  const theme = useTheme();

  if (tabList.length === 0) {
    console.warn('TabListProvider must have more than one tab item');
    return null;
  }

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onTabClick(newValue);
  };

  // 팅글 리워드 메인: 탭 Selected=label/primary · Unselected=label/quaternary (디자인 시안 Figma 1072:58012).
  // 라임(brand/primary)은 흰 배경에서 대비가 안 나와 시안대로 라벨색을 쓴다.
  const isTingle = getServiceName() === 'tingle';
  const selectedColor = isTingle ? theme.color.label.primary : theme.color.static.primary;
  const unselectedColor = isTingle ? theme.color.label.quaternary : 'text.primary';

  return (
    <Tabs
      value={activateTabItem?.type}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        '& .MuiTabs-indicator': {
          height: '3px',
          background: selectedColor,
        },
        '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
          color: selectedColor,
        },
      }}
    >
      {tabList.map((tab) => (
        <Tab
          key={tab.type}
          label={tab.label}
          value={tab.type}
          sx={{
            fontFamily: 'Pretendard, Arial, sans-serif', // 폰트 설정
            fontWeight: 600,
            color: activateTabItem?.type === tab.type ? selectedColor : unselectedColor,
            fontSize: {
              xs: '20px',
              sm: '20px',
              md: '24px',
            },
            marginRight: '24px',
            padding: 0,
            minWidth: 'auto',
          }}
        />
      ))}
    </Tabs>
  );
}

export default TabList;
